"use strict";
/* Copyright (c) 2020, VRAI Labs and/or its affiliates. All rights reserved.
 *
 * This software is licensed under the Apache License, Version 2.0 (the
 * "License") as published by the Apache Software Foundation.
 *
 * You may not use this file except in compliance with the License. You may
 * obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 */
var __awaiter =
    (this && this.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator =
    (this && this.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: []
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === "function" &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y["return"]
                                    : op[0]
                                    ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessState = exports.PROCESS_STATE = void 0;
var PROCESS_STATE;
(function (PROCESS_STATE) {
    //CALLING_INTERCEPTION_REQUEST : Process state for the request interceptor.
    //CALLING_INTERCEPTION_RESOPONSE : Process state for the response interceptor.
    PROCESS_STATE[(PROCESS_STATE["CALLING_INTERCEPTION_REQUEST"] = 0)] = "CALLING_INTERCEPTION_REQUEST";
    PROCESS_STATE[(PROCESS_STATE["CALLING_INTERCEPTION_RESPONSE"] = 1)] = "CALLING_INTERCEPTION_RESPONSE";
})((PROCESS_STATE = exports.PROCESS_STATE || (exports.PROCESS_STATE = {})));
var ProcessState = /** @class */ (function () {
    function ProcessState() {
        var _this = this;
        this.history = [];
        this.addState = function (state) {
            try {
                if (process !== undefined && process.env !== undefined && process.env.TEST_MODE === "testing") {
                    _this.history.push(state);
                }
            } catch (ignored) {}
        };
        this.getEventByLastEventByName = function (state) {
            for (var i = _this.history.length - 1; i >= 0; i--) {
                if (_this.history[i] == state) {
                    return _this.history[i];
                }
            }
            return undefined;
        };
        this.reset = function () {
            _this.history = [];
        };
        this.waitForEvent = function (state, timeInMS) {
            if (timeInMS === void 0) {
                timeInMS = 7000;
            }
            return __awaiter(_this, void 0, void 0, function () {
                var startTime;
                var _this = this;
                return __generator(this, function (_a) {
                    startTime = Date.now();
                    return [
                        2 /*return*/,
                        new Promise(function (resolve) {
                            var actualThis = _this;
                            function tryAndGet() {
                                var result = actualThis.getEventByLastEventByName(state);
                                if (result === undefined) {
                                    if (Date.now() - startTime > timeInMS) {
                                        resolve(undefined);
                                    } else {
                                        setTimeout(tryAndGet, 1000);
                                    }
                                } else {
                                    resolve(result);
                                }
                            }
                            tryAndGet();
                        })
                    ];
                });
            });
        };
    }
    ProcessState.getInstance = function () {
        if (ProcessState.instance == undefined) {
            ProcessState.instance = new ProcessState();
        }
        return ProcessState.instance;
    };
    return ProcessState;
})();
exports.ProcessState = ProcessState;
